import type { SessionContext } from "../api/types";

export const REVENUE_MODULE_FEATURE = "REVENUE_MODULE";

export function hasRevenueAccess(
  session: Pick<SessionContext, "features" | "user">,
): boolean {
  if (session.user.role !== "owner") return false;
  if (!Array.isArray(session.features) || !session.features.includes(REVENUE_MODULE_FEATURE)) return false;
  return true;
}
